module.exports = require("@swa-ui/itinerary/src/FlightTimes/FlightTimes.module.scss");